import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { VimeoService } from '../services/vimeo.service';

export const videoResolver: ResolveFn<any> = async (route) => {
  const service = inject(VimeoService);
  const videoId = route.params.selectedvideo;
  const result = await service.getVimeoInfo(videoId);
  if (result?.id) {
    return result;
  }
  return { id: videoId, isVimeoVideo: false };
};